import React from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import Button from "../CtaButton";

const WhyChooseUs = ({ greenHeading, heading, content, shortHeading, stats, cta, sectionImage, imageStats, altText }) => {
  const { t } = useTranslation("ksaHome");
  const ksaHomeWhyUs = t("whyUs", { returnObjects: true });

  return (
    <>
      <section className="new-why-us-section">
        <div className="container">
          <div className="row align-items-center flex-reverse-section">
            {/* Left Content */}
            <div className="col-xl-6 col-lg-6 col-md-12 mt-5 mt-lg-0">
              <div className="new-why-us-section-box">
                <h3 className="why-us-short-heading-text">{shortHeading}</h3>
                <h2 className="capital-sub-heading">
                  {" "}
                  <span>{greenHeading}</span> {heading}
                </h2>
                <p className="description-text mt-2" dangerouslySetInnerHTML={{
                  __html: content,
                }}></p>

                <div className="why-us-section-stats-box">
                  {(stats || ksaHomeWhyUs.statsData).map((item, index) => {
                    return (
                      <div className="new-why-us-stats" key={index}>
                        <h2 className="new-why-us-stats-heading">
                          {item?.number}
                          <span>{item?.title}</span>
                        </h2>
                      </div>
                    );
                  })}
                </div>

                <div className="why-choose-us-brands-logo">
                  <a
                    href="https://www.youtube.com/watch?v=LDmv2CrkM1c"
                    target="_blank"
                  >
                    <img
                      src="/images/new-Payoneer.svg"
                      width={150}
                      alt="Best Web Development Company Awarded by Payoneer"
                    />
                  </a>

                  <a
                    href="https://clutch.co/profile/bitsclan-it-solutions?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=logo&utm_term=bitsclan.com#highlights"
                    target="_blank"
                  >
                    <img
                      src="/images/new-clutch.svg"
                      width={100}
                      alt="Bitsclan IT Solutions Trusted by Clutch"
                    />
                  </a>

                  {/* <a href="#" style={{ cursor: 'default', }}>
                                        <img src="/images/clutch-icons/PSEB-white.png" width={80} alt="" />
                                    </a> */}
                </div>
                {/* <Button className="mt-5" text={cta?.text} link={cta?.link} /> */}
              </div>
            </div>
            {/* Right Content */}
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="new-why-us-image-box">
                <div className="new-why-us-section-image">
                  <img
                    src={`${sectionImage || "/images/why-us-section/why-us-banner-image.avif"}`}
                    alt={altText || "Why Choose Us"}
                  />
                </div>
                {/* Floating Cards */}
                {/* <div className="new-why-us-floating-card top-left">
                  {imageStats?.[0].number || "120+"} <br />
                  <small>{imageStats?.[0].title || "Projects"}</small>
                </div>
                <div className="new-why-us-floating-card bottom-left">
                  {imageStats?.[1].title || "Custom Softwre Development"} <br />
                  <small>{imageStats?.[1].number || "5 Years"}</small>
                </div>
                <div className="new-why-us-floating-card top-right">
                  <span className="star">★</span> {imageStats?.[2].number || "4.9"} <br />
                  <small>{imageStats?.[2].title || "Satisfaction"}</small>
                </div> */}
                {imageStats?.[0]?.title && (
                  <div className="new-why-us-floating-card top-left">
                    {imageStats?.[0]?.number || "120+"} <br />
                    <small>{imageStats?.[0]?.title || "Projects"}</small>
                  </div>
                )}

                {imageStats?.[1]?.title && (
                  <div className="new-why-us-floating-card bottom-left">
                    {imageStats?.[1]?.number || "5 Years"} <br />
                    <small>{imageStats?.[1]?.title || "Custom Software Development"}</small>
                  </div>
                )}

                {imageStats?.[2]?.title && (
                  <div className="new-why-us-floating-card top-right">
                    <span className="star">★</span> {imageStats?.[2]?.number || "4.9"} <br />
                    <small>{imageStats?.[2]?.title || "Satisfaction"}</small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="new-why-us-sections-logos">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2">
                            <div className="why-us-section-logo">
                                <img src="/images/Clutch-logo.svg" alt="" />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="why-us-section-logo">
                                <img src="/images/payoneer-testimonial.png" alt="" />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="why-us-section-logo">
                                <img src="/images/clutch-icons/clutch-rating3.svg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
    </>
  );
};

export default WhyChooseUs;
